import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  status: {
    consultant_id: null,
    consultant_name: "",
    consultant_code: "",
    avatar: "",
    current_role: "",
    target_role_id: null,
    target_role: "",
    target_role_description: "",
    current_step: 1,
    finished_at: null,
  },
  steps: [],
  ui: {
    documentsSidebar: {
      visible: false,
      currentDocument: null,
    },
    checklistSidebar: {
      visible: false,
      currentItem: null,
    },
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
